import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { type UpdatedMessage } from 'stream-chat';
import { ArrowRightIcon } from '../../icons/ArrowRightIcon';
import { ArrowUpIcon } from '../../icons/ArrowUpIcon';
import styles from './SendButton.module.css';

export type SendButtonProps = {
  className?: string;
  disabled: boolean;
  onClick: (
    event?: React.BaseSyntheticEvent,
    customMessageData?: Omit<UpdatedMessage, 'mentioned_users'>,
  ) => void;
};
export const SendButton: FunctionComponent<SendButtonProps> = ({
  className,
  disabled,
  onClick,
}) => {
  return (
    <div className={cx(styles.root, className)}>
      <button
        className={cx(styles.button, disabled && styles.disabled)}
        disabled={disabled}
        onClick={onClick}
        type="button"
      >
        {disabled ? <ArrowRightIcon /> : <ArrowUpIcon />}
      </button>
    </div>
  );
};
